import React from 'react';
import ReactDOM from 'react-dom';
import { Container, Row, Col, Button, Modal, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { FaDatabase, FaSignOutAlt, FaUser, FaUserClock, FaUserFriends } from 'react-icons/fa';
import { isMobile } from 'react-device-detect';

import { LoginPage } from "./loginPage";
import { UsersPage } from './usersPage';
import { UserProfilePage } from './userProfilePage';
import { LoggedInUsersPage } from './loggedInUsersPage';
import { AllMoviesPage } from './allMoviesPage';
import { TopMoviesPage } from './topMoviesPage';
import { RandomMoviePage } from './randomMoviePage';
import { BackupsPage } from './backupsPage';

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


class Intrashtenimento extends React.Component {
    constructor(props) {
        super(props);

        this.isWindowWidthNarrow = window.matchMedia('(max-width: 765px)');
        this.isWindowWidthNarrow.addEventListener('change', () => this.updateRenderAsMobile());
        const isNarrow = this.isWindowWidthNarrow.matches;
          
        this.state = {
            renderAsMobile: isNarrow || isMobile,

            user: null,
            currentPage: sessionStorage.getItem("currentPage") || "all-movies",
            showErrorModal: false,
            errorModalText: ""
        };
  
        this.refreshLoggedInUser();
    }

    async updateRenderAsMobile() {
        const isNarrow = this.isWindowWidthNarrow.matches;
        this.setState({ renderAsMobile: isNarrow || isMobile });
    }

    setLoggedInUser(u) {
        sessionStorage.setItem("currentPage", "all-movies");
        this.setState({ currentPage: "all-movies", user: u });
    }

    refreshLoggedInUser() {
        IntrashBackend.getLoggedInUser().then(u => this.setState({ user: u }));
    }

    logout() {
        IntrashBackend.logout().then(() => this.setState({ user: null }));
    }

    setCurrentPage(page) {
        sessionStorage.setItem("currentPage", page);
        this.setState({ currentPage: page });
    }

    async addUser() {
        try {
            const newUser = await IntrashBackend.addUser();
            this.setState({ currentPage: "user-profile", userProfilePageUser: newUser });
        }
        catch (e) {
            this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + e });
        }
    }

    renderNavBarLinks() {
        if (this.state.user !== null) {
            return (  
                <Nav className="mr-auto">
                    <Nav.Link active={this.state.currentPage === "all-movies"} onClick={() => this.setCurrentPage("all-movies")}>All Movies</Nav.Link>
                    <Nav.Link active={this.state.currentPage === "top-unwatched-movies"} onClick={() => this.setCurrentPage("top-unwatched-movies")}>Top Unwatched</Nav.Link>
                    <Nav.Link active={this.state.currentPage === "top-watched-movies"} onClick={() => this.setCurrentPage("top-watched-movies")}>Top Watched</Nav.Link>
                    <Nav.Link active={this.state.currentPage === "worst-watched-movies"} onClick={() => this.setCurrentPage("worst-watched-movies")}>Worst Watched</Nav.Link>
                    <Nav.Link active={this.state.currentPage === "random-movie"} onClick={() => this.setCurrentPage("random-movie")}>Random Movie</Nav.Link>
                </Nav>
            );
        }
    }
    renderNavBarUserDropDown() {
        const renderUsersItem = () => {
            if (this.state.user !== null & this.state.user.canEditUsers) {
                return (
                    <NavDropdown.Item onClick={() => this.setCurrentPage("users")}>
                        <Row noGutters>
                            <Col xs="auto" style={{ paddingRight: "0.75em"}}><FaUserFriends/></Col>
                            <Col>Users</Col>
                        </Row>
                    </NavDropdown.Item>
                );
            }
        }
        const renderLoggedInUsersItem = () => {
            if (this.state.user !== null & this.state.user.canEditUsers) {
                return (
                    <NavDropdown.Item onClick={() => this.setCurrentPage("logged-in-users")}>
                        <Row noGutters>
                            <Col xs="auto" style={{ paddingRight: "0.75em"}}><FaUserClock/></Col>
                            <Col>Sessions</Col>
                        </Row>
                    </NavDropdown.Item>
                );
            }
        }
        const renderBackupsUsersItem = () => {
            if (this.state.user !== null & this.state.user.canEditMovies) {
                return (
                    <NavDropdown.Item onClick={() => this.setCurrentPage("backups")}>
                        <Row noGutters>
                            <Col xs="auto" style={{ paddingRight: "0.75em"}}><FaDatabase/></Col>
                            <Col>Backups</Col>
                        </Row>
                    </NavDropdown.Item>
                );
            }
        }
        if (this.state.user !== null) {
            return (
                <Nav>
                    <NavDropdown title={this.state.user.username} id="collasible-nav-dropdown">
                    <NavDropdown.Item onClick={() => this.setState({ currentPage: "user-profile", userProfilePageUser: this.state.user })}>
                        <Row noGutters>
                            <Col xs="auto" style={{ paddingRight: "0.75em"}}><FaUser/></Col>
                            <Col>Profile</Col>
                        </Row>
                    </NavDropdown.Item>
                    {renderUsersItem()}
                    {renderLoggedInUsersItem()}
                    {renderBackupsUsersItem()}
                    <NavDropdown.Divider/>
                    <NavDropdown.Item onClick={() => this.logout()}>
                        <Row noGutters>
                            <Col xs="auto" style={{ paddingRight: "0.75em"}}><FaSignOutAlt/></Col>
                            <Col>Log out</Col>
                        </Row>
                    </NavDropdown.Item>
                    </NavDropdown>
                </Nav>
            );
        }
    }
    renderNavBar() {
        return (
            <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top">
                <Navbar.Brand>Intrashtenimento</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    {this.renderNavBarLinks()}
                    {this.renderNavBarUserDropDown()}
                </Navbar.Collapse>
            </Navbar>
        );
    }

    filterTopMovies(movies, votes, n=20) {
        // Calculate the average votes of each movie
        const averageVote = (movieId) => {
            if (votes[movieId] === undefined) return null;
            var voteCount = 0;
            var totalVote = 0.0;
            Object.values(votes[movieId]).forEach(v => { totalVote += v; ++voteCount; });
            return voteCount > 0 ? (totalVote / voteCount) : 0;
        }
        var movieAverageVotes = {}
        movies.forEach(m => { movieAverageVotes[m.id] = averageVote(m.id); });

        // Sort the movies
        const compareMethod = (a, b) => { return movieAverageVotes[a.id] > movieAverageVotes[b.id] ? -1 : 1 };
        movies.sort(compareMethod);

        // Pick the first N (unwatched) movies
        return movies.slice(0, n);
    }

    filterBottomMovies(movies, votes, n=20) {
        // Calculate the average votes of each movie
        const averageVote = (movieId) => {
            if (votes[movieId] === undefined) return null;
            var voteCount = 0;
            var totalVote = 0.0;
            Object.values(votes[movieId]).forEach(v => { totalVote += v; ++voteCount; });
            return voteCount > 0 ? (totalVote / voteCount) : 0;
        }
        var movieAverageVotes = {}
        movies.forEach(m => { movieAverageVotes[m.id] = averageVote(m.id); });

        // Sort the movies
        const compareMethod = (a, b) => { return movieAverageVotes[a.id] < movieAverageVotes[b.id] ? -1 : 1 };
        movies.sort(compareMethod);

        // Pick the first N (unwatched) movies
        return movies.slice(0, n);
    }

    filterTopWatchedMovies(movies, votes, n=20) {
        // Extract the watched movies
        var watchedMovies = []
        movies.forEach(m => { if (m.watched) watchedMovies.push(m) });

        // Select the top N movies
        return this.filterTopMovies(watchedMovies, votes, n);
    }

    filterWorstWatchedMovies(movies, votes, n=20) {
        // Extract the watched movies
        var watchedMovies = []
        movies.forEach(m => { if (m.watched) watchedMovies.push(m) });

        // Select the bottom N movies
        return this.filterBottomMovies(watchedMovies, votes, n);
    }

    filterTopUnwatchedMovies(movies, votes, n=20) {
        // Extract the unwatched movies
        var unwatchedMovies = []
        movies.forEach(m => { if (!m.watched) unwatchedMovies.push(m) });

        // Select the top N movies
        return this.filterTopMovies(unwatchedMovies, votes, n);
    }
    
    renderContent() {
        // Check if the user is logged-in
        if (this.state.user === null) {
            // Show the log-in page
            return (
                <Container fluid="sm">
                    <LoginPage onLogIn={(u) => this.setLoggedInUser(u)}/>
                </Container>
            );
        }

        //else

        // Check which tab is currently selected
        if (this.state.currentPage === "all-movies") {
            // Show the All Movies page
            return (
                <Container fluid="sm">
                    <AllMoviesPage renderAsMobile={this.state.renderAsMobile}/>
                </Container>
            );
        }
        else if (this.state.currentPage === "top-unwatched-movies") {
            // Show the All Movies page
            return (
                <Container fluid="sm">
                    <TopMoviesPage title="Top Unwatched Movies" moviesFilter={(movies, votes) => this.filterTopUnwatchedMovies(movies, votes)}/>
                </Container>
            );
        }
        else if (this.state.currentPage === "top-watched-movies") {
            // Show the All Movies page
            return (
                <Container fluid="sm">
                    <TopMoviesPage title="Top Watched Movies" moviesFilter={(movies, votes) => this.filterTopWatchedMovies(movies, votes)}/>
                </Container>
            );
        }
        else if (this.state.currentPage === "worst-watched-movies") {
            // Show the All Movies page
            return (
                <Container fluid="sm">
                    <TopMoviesPage title="Worst Watched Movies" moviesFilter={(movies, votes) => this.filterWorstWatchedMovies(movies, votes)}/>
                </Container>
            );
        }
        else if (this.state.currentPage === "random-movie") {
            // Show the Random Movie page
            return (
                <Container fluid="sm">
                    <RandomMoviePage/>
                </Container>
            )
        }
        else if (this.state.currentPage === "user-profile") {
            // Show the User Profile page
            return (
                <Container fluid="sm">
                    <UserProfilePage user={this.state.userProfilePageUser} onUsernameChanged={(u) => this.refreshLoggedInUser()}/>
                </Container>
            );
        }
        else if (this.state.currentPage === "users") {
            // Show the Users page
            return (
                <Container fluid="sm">
                    <UsersPage onAddUser={() => this.addUser()} onEditUser={(u) => this.setState({ currentPage: "user-profile", userProfilePageUser: u })}/>
                </Container>
            );
        }
        else if (this.state.currentPage === "logged-in-users") {
            // Show the Logged In Users page
            return (
                <Container fluid="sm">
                    <LoggedInUsersPage/>
                </Container>
            );
        }
        else if (this.state.currentPage === "backups") {
            // Show the Logged In Users page
            return (
                <Container fluid="sm">
                    <BackupsPage/>
                </Container>
            );
        }
    }

    render() {
        return (
            <>
                {this.renderNavBar()}
                <div style={{ paddingTop: "70px" }}>
                    <br/>
                    {this.renderContent()}
                    <br/>
                </div>
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}


ReactDOM.render(<Intrashtenimento/>, document.getElementById('root'));
